export default "__VITE_ASSET__CWKyHNX1__"